import { motion } from "framer-motion";
import { useMatch } from "@/match/MatchContext";
import { CommentaryButton } from "./StorySection";
import { SECTIONS } from "@/data/content";

// HALF-TIME — quiet, reflective, cream tones, generous space.
export default function HalfTime() {
  const { openCommentary } = useMatch();
  const section = SECTIONS.halftime;

  return (
    <div
      className="relative bg-[#F5F1E8] border-b-4 border-black py-24 sm:py-36 px-4 sm:px-8 lg:px-16 overflow-hidden"
      data-testid="halftime-section"
    >
      {/* faint centre-circle echo */}
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[620px] h-[620px] rounded-full border border-black/[0.07] pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative max-w-3xl mx-auto text-center">
        <motion.span
          className="inline-block border-2 border-black text-black font-broadcast font-bold text-[10px] sm:text-xs tracking-[0.3em] uppercase px-4 py-2 mb-8"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          data-testid="halftime-label"
        >
          {section.minuteEvent}
        </motion.span>
        <motion.h2
          className="font-display uppercase text-3xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-black mb-8"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.05 }}
        >
          {section.headline}
        </motion.h2>
        <motion.p
          className="text-base sm:text-lg font-medium leading-relaxed text-black/70 max-w-xl mx-auto mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.12 }}
        >
          {section.preview}
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <CommentaryButton
            onClick={() => openCommentary("halftime")}
            testId="halftime-commentary-btn"
          />
        </motion.div>
      </div>
    </div>
  );
}
